
<template>
	<div ref="listWrap">
		<wrapper-list
		    @add="paasAddPage"
            @calculate="paasCalculate"
		    ref="wrapperList" >
      	<Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
      	</Form>
      	<Table slot="table" stripe border :height="tableHeight"
             :data="tableData"
             :columns="tableColumns"
             @on-selection-change="selectTableDataChange"
             @on-sort-change="sortTableData"
             :no-data-text="noDataText">
        </Table>
        <Page slot="page"  :total="totalRecords"
            show-total show-sizer
            @on-change="changePage"
            @on-page-size-change="changePageSize">
        </Page>
        </wrapper-list>
   </div>
</template>
<script>
	  import wrapperList from "@/components/paas/wrapper-list";
    import metaList from "@/assets/js/list/meta-list.js";
    import CellBar from '@/components/paas/cell-bar' //列表内操作

    export default {
      name: "list",
      mixins: [ metaList ],
      components: { wrapperList,CellBar},
      data() {
      	return {
      		serviceUrl:"/eb/entity/card/batch/product",  //每个页面访问后台服务器的路径
      		currentIdFiledName: 'id',
      		queryParam:{

	        },
	        defaultLabelWidth:200,
	        tableColumns:[
	        	{
	        		title: '卡名称',
	        		key: 'cardName',
	        	},
	        	{
	        		title: '面值',
	        		key: 'faceValue',
	        	},
	        	{
	        		title: '售价',
	        		key: 'saleValue',
	        	},
	        	{
	        		title: '制作数量',
	        		key: 'productNum',
	        	},
	        	{
	        		title: '批次号',
	        		key: 'batchId',
	        	},
	        	{
	        		title: '编码前缀',
	        		key: 'codePrefix',
	        	},
            {
               title: '创建时间',
               key: 'timeCreate',
            },
	        	{
	        		title: '操作',
	        		render: (h, params) => {
		                return h(CellBar,
		                    {
			                  props:{
			                    show:'textIcon'  //操作也显示标准按钮的样式（text、icon、textIcon）
			                  },
			                  //自定义事件监听器“on”,不支持如v-on:keyup.enter的修饰符，需要手动匹配keyCode
			                    on: {
			                      // 子组件$emit传递函数,必须是箭头函数写法
									  'edit': ()=> {
										this.$nextTick(()=>{
										  this.paasEditOper(params.row[this.currentIdFiledName]);
										})
									  },
									'export':()=>{
									  this.$nextTick(()=>{
										this.paasExportOper(params.row[this.currentIdFiledName]);
									  })
									}

			                    }
			                }
			            )
		            }
		         }
	        ],
      	}
      },
      mounted(){

      },
      methods:{
        paasExportOper(id){
          window.open(this.$store.state.sysApi+this.serviceUrl+"/exportCardDatas?"+getParam);
        },
      }
    }
</script>
